
import React, { useState } from "react";

const AddMore = () => {
    const [addresses, setAddresses] = useState([""]);

    const handleAddAddress = () => {
        setAddresses([...addresses, ""]); // Add a new empty address field
    };

    const handleRemoveAddress = (index) => {
        const newAddresses = addresses.filter((_, i) => i !== index);
        setAddresses(newAddresses);
    };

    const handleAddressChange = (index, value) => {
        const newAddresses = [...addresses];
        newAddresses[index] = value;
        setAddresses(newAddresses);
    };

    return (
        <div className="">
            {addresses.map((address, index) => (
                <div key={index} className="mb-3 d-flex align-items-center gap-10">
                    <textarea
                        className="form-control"
                        rows="2"
                        placeholder={`Address ${index + 1}`}
                        value={address}
                        onChange={(e) => handleAddressChange(index, e.target.value)}
                    />
                    {addresses.length > 1 && (
                        <button
                            className="btn btn-danger btn-sm"
                            onClick={() => handleRemoveAddress(index)}
                        >
                        Remove
                        </button>
                    )}
                </div>
            ))}
            <button className="btn btn-primary btn-sm" onClick={handleAddAddress}>
              Add More
            </button>
        </div>
    );
}

export default AddMore;
